<div
  class="error-state"
  [class.error-state--small]="size === 'small'"
  [class.error-state--tiny]="size === 'tiny'"
  [class.error-state--medium]="size === 'medium'"
  [class.error-state--large]="size === 'large'"
  [class.error-state--transparent]="transparent"
>
  @if (size === 'large') {
    <ftr-illustration class="error-state__icon" [illustration]="illustration.Error" />
  } @else {
    <ftr-icon-legacy class="error-state__icon" icon="ErrorCircleLine" color="Brand" size="ExtraLarge" align="Middle" />
  }

  <div class="error-state__content">
    @if (errorMessage) {
      <p>{{ errorMessage }}</p>
    } @else {
      <p class="error-state__title">
        @if (entityName) {
          {{ entityName | ftrCapitalizeFirstLetter }} failed to load
        } @else {
          Failed to Load
        }
      </p>
      <p>Please reload the page or try again later.</p>
      <ftr-tertiary-button (click)="onRetry.emit()" theme="primary" text="Reload Page" />
    }
  </div>
</div>
